




































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import TransactionalFeesCreateDialog from '@/components/Products/ProductFees/Transactional/TransactionalFeesCreateDialog.vue';
import TransactionalFeesEditDialog from '@/components/Products/ProductFees/Transactional/TransactionalFeesEditDialog.vue';
import TransactionalFeesDeleteDialog from '@/components/Products/ProductFees/Transactional/TransactionalFeesDeleteDialog.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import EntityType from '@/models/Shared/EntityType';
import TransactionalFee from '@/models/Products/ProductFees/TransactionalFee';

@Component({ name: 'TransactionalFees', components: { TransactionalFeesCreateDialog, TransactionalFeesEditDialog, TransactionalFeesDeleteDialog } })
export default class extends SaascadaVue {

    EntityType = EntityType;
    headers = [
        { text: this.$t('pageText.products.fields.name'), width: "100%" }
    ];
    transactionalFeesPage = 1;

    @Prop({required: true})
    entityType: EntityType;

    @Watch('transactionalFeesPage')
    async onTransactionalFeesPageChanged() {
        // Preselect the first row on the next page
        // NOTE: This is only needed when paginating locally through results
        const nextItemIndex = (this.transactionalFeesPage - 1) * this.pageSize;
        const nextItem = this.transactionalFees[nextItemIndex];
        await ProductDetailsModule.updateCurrentTransactionalFee(nextItem);
    }

    async updateCurrentTransactionalFee(transactionalFee: TransactionalFee) {
        await ProductDetailsModule.updateCurrentTransactionalFee(transactionalFee);
    }

    get currentTransactionalFee() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.currentTransactionalFee;
        }
        return ProductIssueDetailsModule.currentTransactionalFee;
    }

    get transactionalFees() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.generalFeeSettings.transactionalFees;
        }
        return ProductIssueDetailsModule.productIssue.generalFeeSettings.transactionalFees;
    }

    get totalTransactionalFeesPages() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.totalTransactionalFeesPages;
        }
        return ProductIssueDetailsModule.totalTransactionalFeesPages;
    }

    get loading() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.loading;
        }
        return ProductIssueDetailsModule.loading;
    }

    get pageSize() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.pageSize;
        }
        return ProductIssueDetailsModule.pageSize;
    }

}
